module.exports = __webpack_public_path__ + "Assets/PREMIUM_nordwest.jpg";